export default __webpack_public_path__ + "static/entertainment-a4c65b627bb275e50f75edc6640cb3be.svg";